<section class="widget-area">
<mat-card>
  <mat-card-content>
    <h1>Mein Profil</h1>

    @if (showNotification) {
      <div [class]="notification.type" class="notification d-flex jcc aic p-m mb-l">
        @if (notification.type === 'info') {
          <mat-icon fontSet="material-symbols-outlined" aria-hidden="false" class="mr-m">info_outline</mat-icon>
        }
        @if (notification.type === 'warn') {
          <mat-icon fontSet="material-symbols-outlined" aria-hidden="false" color="error" class="mr-m">error_outline
          </mat-icon>
        }
        <p [innerHTML]="notification.html" class="m-m"></p>
      </div>
    }

    <div class="user-inline">
      <h4 class="label">Name:</h4>
      <span class="value">{{ user?.salutation }} {{ user?.title }} {{ user?.name }}</span>
      <mat-icon fontSet="material-symbols-outlined" aria-hidden="false"matTooltip="Bearbeiten"
                (click)="openUserDataChangeDialog()" class="cursor-pointer">edit</mat-icon>
    </div>

    <div class="user-inline">
      <h4 class="label">Benutzername:</h4>
      <span class="value">{{ user?.username }}</span>
    </div>

    <div class="user-inline">
      <h4 class="label">Passwort:</h4>
      <span class="value">********</span>
      <mat-icon fontSet="material-symbols-outlined" aria-hidden="false" matTooltip="Bearbeiten"
                (click)="openPasswordChangeDialog()" class="cursor-pointer">edit</mat-icon>
    </div>
  </mat-card-content>
</mat-card>
</section>
